import { DeviceTypeEnum } from 'shared/hooks/use-metadata-from-server'
import { BreakpointsStateInterface } from '../types/breakpoints-state'

export const serverDeviceBreakpointOverrides: Record<
  DeviceTypeEnum,
  Partial<BreakpointsStateInterface>
> = {
  [DeviceTypeEnum.Desktop]: {
    isSM: true,
    isMD: true,
    isLG: true,
  },
  [DeviceTypeEnum.Mobile]: {
    isXS: true,
  },
  [DeviceTypeEnum.Tablet]: {
    isSM: true,
  },
  [DeviceTypeEnum.Unknown]: {},
}
